export class MessagType {
    static Success = "success";
    static Error = "error";
    static Data = "data";
    static MarkerData = "markerdata";
}